<script setup lang="ts">
import { h, resolveComponent, useAttrs, useSlots } from 'vue'
import { useTrailingSlash } from '../../composables/trailingSlash'

const { cached_url, url, href, to, blank, story } = defineProps<{
  id?: string
  to?: string
  href?: string
  url?: string
  linktype?: string
  fieldtype?: string
  // eslint-disable-next-line vue/prop-name-casing
  cached_url?: string
  blank?: boolean
  story?: {
    name: string
    id: number
    uuid: string
    slug: string
    url: string
    full_slug: string
  }
}>()
const slots = useSlots()
const attrs = useAttrs()
let component: any = 'div'
const params = { ...attrs }
if (url || href) {
  component = 'a'
  params.href = url || href
  params.target = blank ? '_blank' : url?.startsWith('/') || url?.startsWith('#') ? '_self' : '_blank'
}
else if (story?.full_slug) {
  component = resolveComponent('NuxtLink')
  params.to = useTrailingSlash(story?.full_slug.substring(story?.full_slug.indexOf('pages/') + 5))
}
else if (cached_url || to) {
  component = resolveComponent('NuxtLink')
  params.to = useTrailingSlash(cached_url ? cached_url.startsWith('/') ? cached_url : new URL(cached_url).pathname : to)
}
const root = h(component, params, slots)
</script>

<template>
  <component :is="root" />
</template>
